import { DataTable } from "@fdoh/health-react";
import { Layout, Page, usePath, Card, Button } from "@fdoh/health-ui-react";
import { useData } from "../../hooks";
import { InspectionStatusInput } from "./InspectionHome.types";
import { useEffect, useState, useRef, createContext } from "react";
import http from "../../../http-common";
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { useHistory } from "react-router-dom";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import useClient from "../../hooks/useInspectionClient";
import { toast } from "react-toastify";


export const InspectionHomePage = () => {
    const path = usePath();
    const history = useHistory();
    const client = useClient();
    const inspectionStatusData = useData<InspectionStatusInput>(path.current);
    const HideNextButton = !((
        inspectionStatusData?.inspectionStatusId == 1 &&
        inspectionStatusData?.tankInstallationInspectionId == 2 &&
        inspectionStatusData?.drainfieldInstallationInspectionId == 2 &&
        inspectionStatusData?.fillExcavationMaterialInspectionId == 2 &&
        inspectionStatusData?.setBackInspectionId == 2 &&
        inspectionStatusData?.filledMoundSystemInspectionId == 2 &&
        inspectionStatusData?.additionalInformationInspectionId == 2 &&
        inspectionStatusData?.abandonmentInspectionId == 2) || (inspectionStatusData?.inspectionStatusId == 2 ))
 
    const deleteInspection = async () => {
        if (window.confirm('Are you sure you want to delete?')) {
            try {
                let endpoint = 'ApplicationInspection/' + inspectionStatusData?.applicationInspectionId;
                const response = await client.api(endpoint).delete();
                if (response.ok) {
                    history.push(`/`);
                }
            } catch (error: any) {
                toast.error(error);
            }
        }    
}
    const goToTankInstallationPage = () => {
        history.push({
            pathname: "/tankInstallation/",
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToEditTankInstallationPage = () => {
        history.push({
            pathname: "/tankInstallation/" + inspectionStatusData?.tankInstallationId,
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                })
    }
    const goToDrainFieldInstallationPage = () => {
        history.push({
            pathname: "/drainfieldInstallation/",
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToEditDrainFieldInstallationPage = () => {
        history.push({
            pathname: "/drainfieldInstallation/"+ inspectionStatusData?.drainfieldInstallationId,
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToFillExcavationMaterialPage = () => {
        history.push({
            pathname: "/fillExcavationMaterial/",
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToEditFillExcavationMaterialPage = () => {
        history.push({
            pathname: "/fillExcavationMaterial/"+ inspectionStatusData?.fillExcavationMaterialId,
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToSetBacksPage = () => {
        history.push({
            pathname: "/setbacks/",
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToEditSetBacksPage = () => {
        history.push({
            pathname: "/setbacks/"+ inspectionStatusData?.setBackId,
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
            
        })
    }
    const goToFilledMoundSystemPage = () => {
        history.push({
            pathname: "/filledMoundSystem/",
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToEditFilledMoundSystemPage = () => {
        history.push({
            pathname: "/filledMoundSystem/"+ inspectionStatusData?.filledMoundSystemId,
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToAdditionalInformationPage = () => {
        history.push({
            pathname: "/AdditionalInformation/",
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToEditAdditionalInformationPage = () => {
        history.push({
            pathname: "/AdditionalInformation/"+ inspectionStatusData?.additionalInformationId,
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToAbandonmentPage = () => {
        history.push({
            pathname: "/abandonment/",
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    const goToEditAbandonmentPage = () => {
        history.push({
            pathname: "/abandonment/"+ inspectionStatusData?.abandonmentId,
            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
        })
    }
    /*==============================================================================================================================================*/
    const goToSummaryPage = () => {
        if (inspectionStatusData?.inspectionStatusId == 2) {
            history.push(
                {
                    pathname: "/summaryView/",
                    search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                })
        }

        else if (inspectionStatusData?.inspectionStatusId == 1) {
            history.push(
                {
                    pathname: "/submitInspection/",
                    search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                })
        }

    }
    /*==============================================================================================================================================*/
    const goToSearchPage = () => {
        history.push("/")
    }
    return (
        <Page.Container>
            {inspectionStatusData && (<ApplicationDetailsPage id={inspectionStatusData?.applicationId}></ApplicationDetailsPage>)}
            <Page.Header preTitle="" title="Construction Inspection">
                <div className="col col-lg-4">
                    <a onClick={deleteInspection} className="btn btn-outline-primary btn-pill">
                        Delete Inspection
                    </a>
                </div>
            </Page.Header>
            <div className="container-xl">
                <p>Please complete all sections below in order to submit this report.</p>
            </div>
            <Page.Body>
                <Layout.Container>                    
                    <div className="page-body">
                        <div className="container-xl">
                            <div className="row row-cards">
                                <div className="col-md-6 col-lg-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
                                                    <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2"></path>
                                                    <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                    <path d="M8 11h4"></path>
                                                    <path d="M8 15h3"></path>
                                                    <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
                                                    <path d="M18.5 19.5l2.5 2.5"></path>
                                                </svg> Tank Installation
                                            </h3>
                                            <p className="text-muted">Record Tank size, material and other important details.</p>
                                        </div>
                                        {/* <!-- Card footer --> */}
                                        <div className="card-footer">
                                            <div className="d-flex">
                                                {inspectionStatusData?.tankInstallationInspectionId &&
                                                    inspectionStatusData?.tankInstallationInspectionId === InspectionStatus.Complete &&
                                                    (<><a className="btn btn-link green-btn-link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M5 12l5 5l10 -10"></path>
                                                        </svg>Complete</a>
                                                        <a onClick={goToEditTankInstallationPage} className="btn btn-primary ms-auto">Edit</a></>)}
                                                {(inspectionStatusData?.tankInstallationInspectionId === null || inspectionStatusData?.tankInstallationInspectionId === undefined) &&
                                                    (<>
                                                        <div className="col-xl-12">
                                                            <a onClick={goToTankInstallationPage} className="btn btn-primary d-flex">Get Started</a>
                                                        </div>
                                                    </>)}
                                                {inspectionStatusData?.tankInstallationInspectionId &&
                                                    (inspectionStatusData?.tankInstallationInspectionId === InspectionStatus.Incomplete) &&
                                                    (<><a onClick={goToEditTankInstallationPage} className="btn btn-primary d-flex">Continue</a>
                                                    </>)}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
                                                    <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2"></path>
                                                    <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                    <path d="M8 11h4"></path>
                                                    <path d="M8 15h3"></path>
                                                    <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
                                                    <path d="M18.5 19.5l2.5 2.5"></path>
                                                </svg> Drainfield Installation
                                            </h3>
                                            <p className="text-muted">Indicate area, slope, number of drainlines and more.</p>
                                        </div>
                                        {/* <!-- Card footer --> */}
                                        <div className="card-footer">
                                            <div className="d-flex">
                                                {inspectionStatusData?.drainfieldInstallationInspectionId &&
                                                    inspectionStatusData?.drainfieldInstallationInspectionId === 2 &&
                                                    (<><a className="btn btn-link green-btn-link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M5 12l5 5l10 -10"></path>
                                                        </svg>Complete</a>
                                                        <a onClick={goToEditDrainFieldInstallationPage} className="btn btn-primary ms-auto">Edit</a></>)}
                                                {(inspectionStatusData?.drainfieldInstallationInspectionId === null ||
                                                    inspectionStatusData?.drainfieldInstallationInspectionId === undefined) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToDrainFieldInstallationPage} className="btn btn-primary d-flex">Get Started</a>
                                                        </div>
                                                    </>)}
                                                {inspectionStatusData?.drainfieldInstallationInspectionId &&
                                                    (inspectionStatusData?.drainfieldInstallationInspectionId === 1) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToEditDrainFieldInstallationPage} className="btn btn-primary d-flex">Continue</a>
                                                        </div>
                                                    </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
                                                    <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2"></path>
                                                    <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                    <path d="M8 11h4"></path>
                                                    <path d="M8 15h3"></path>
                                                    <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
                                                    <path d="M18.5 19.5l2.5 2.5"></path>
                                                </svg> Fill/Excavation Material
                                            </h3>
                                            <p className="text-muted">Document fill amount, texture, excavation depth.</p>
                                        </div>
                                        {/* <!-- Card footer --> */}
                                        <div className="card-footer">
                                            <div className="d-flex">
                                                {inspectionStatusData?.fillExcavationMaterialInspectionId &&
                                                    inspectionStatusData?.fillExcavationMaterialInspectionId === InspectionStatus.Complete &&
                                                    (<><a className="btn btn-link green-btn-link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M5 12l5 5l10 -10"></path>
                                                        </svg>Complete</a>
                                                        <a onClick={goToEditFillExcavationMaterialPage} className="btn btn-primary ms-auto">Edit</a></>)}
                                                {(inspectionStatusData?.fillExcavationMaterialInspectionId === null ||
                                                    inspectionStatusData?.fillExcavationMaterialInspectionId === undefined) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToFillExcavationMaterialPage} className="btn btn-primary d-flex">Get Started</a>
                                                        </div>

                                                    </>)}
                                                {inspectionStatusData?.fillExcavationMaterialInspectionId &&
                                                    (inspectionStatusData?.fillExcavationMaterialInspectionId === InspectionStatus.Incomplete) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToEditFillExcavationMaterialPage} className="btn btn-primary d-flex">Continue</a>
                                                        </div>
                                                    </>)}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
                                                    <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2"></path>
                                                    <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                    <path d="M8 11h4"></path>
                                                    <path d="M8 15h3"></path>
                                                    <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
                                                    <path d="M18.5 19.5l2.5 2.5"></path>
                                                </svg> Setbacks
                                            </h3>
                                            <p className="text-muted">Provide measurements for setbacks on the property.</p>
                                        </div>
                                        {/* <!-- Card footer --> */}
                                        <div className="card-footer">
                                            <div className="d-flex">
                                                {inspectionStatusData?.setBackInspectionId &&
                                                    inspectionStatusData?.setBackInspectionId === InspectionStatus.Complete &&
                                                    (<><a className="btn btn-link green-btn-link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M5 12l5 5l10 -10"></path>
                                                        </svg>Complete</a>
                                                        <a onClick={goToEditSetBacksPage} className="btn btn-primary ms-auto">Edit</a>
                                                    </>)}
                                                {(inspectionStatusData?.setBackInspectionId === null ||
                                                    inspectionStatusData?.setBackInspectionId === undefined) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToSetBacksPage} className="btn btn-primary d-flex">Get Started</a>
                                                        </div>
                                                    </>)}
                                                {inspectionStatusData?.setBackInspectionId &&
                                                    (inspectionStatusData?.setBackInspectionId === InspectionStatus.Incomplete) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToEditSetBacksPage} className="btn btn-primary d-flex">Continue</a>
                                                        </div>
                                                    </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
                                                    <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2"></path>
                                                    <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                    <path d="M8 11h4"></path>
                                                    <path d="M8 15h3"></path>
                                                    <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
                                                    <path d="M18.5 19.5l2.5 2.5"></path>
                                                </svg> Filled/Mound System
                                            </h3>
                                            <p className="text-muted">Record stabilization data and slope, shoulder and cover compliance. </p>
                                        </div>
                                        {/* <!-- Card footer --> */}
                                        <div className="card-footer">
                                            <div className="d-flex">
                                                {inspectionStatusData?.filledMoundSystemInspectionId &&
                                                    inspectionStatusData?.filledMoundSystemInspectionId === InspectionStatus.Complete &&
                                                    (<><a className="btn btn-link green-btn-link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M5 12l5 5l10 -10"></path>
                                                        </svg>Complete</a>
                                                        <a onClick={goToEditFilledMoundSystemPage} className="btn btn-primary ms-auto">Edit</a></>)}
                                                {(inspectionStatusData?.filledMoundSystemInspectionId === null ||
                                                    inspectionStatusData?.filledMoundSystemInspectionId === undefined) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToFilledMoundSystemPage} className="btn btn-primary d-flex">Get Started</a>
                                                        </div>
                                                    </>)}
                                                {inspectionStatusData?.filledMoundSystemInspectionId &&
                                                    (inspectionStatusData?.filledMoundSystemInspectionId === InspectionStatus.Incomplete) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToEditFilledMoundSystemPage} className="btn btn-primary d-flex">Continue</a>
                                                        </div>
                                                    </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
                                                    <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2"></path>
                                                    <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                    <path d="M8 11h4"></path>
                                                    <path d="M8 15h3"></path>
                                                    <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
                                                    <path d="M18.5 19.5l2.5 2.5"></path>
                                                </svg> Additional Information
                                            </h3>
                                            <p className="text-muted">Provide any other details to support compliance.</p>
                                        </div>
                                        {/* <!-- Card footer --> */}
                                        <div className="card-footer">
                                            <div className="d-flex">
                                                {inspectionStatusData?.additionalInformationInspectionId &&
                                                    inspectionStatusData?.additionalInformationInspectionId === InspectionStatus.Complete &&
                                                    (<><a href="#" className="btn btn-link green-btn-link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M5 12l5 5l10 -10"></path>
                                                        </svg>Complete</a>
                                                        <a onClick={goToEditAdditionalInformationPage} className="btn btn-primary ms-auto">Edit</a></>)}
                                                {(inspectionStatusData?.additionalInformationInspectionId === null ||
                                                    inspectionStatusData?.additionalInformationInspectionId === undefined) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToAdditionalInformationPage} className="btn btn-primary d-flex">Get Started</a>
                                                        </div>
                                                    </>)}
                                                {inspectionStatusData?.additionalInformationInspectionId &&
                                                    (inspectionStatusData?.additionalInformationInspectionId === InspectionStatus.Incomplete) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToEditAdditionalInformationPage} className="btn btn-primary d-flex">Continue</a>
                                                        </div>
                                                    </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-report-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                    <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"></path>
                                                    <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2"></path>
                                                    <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                    <path d="M8 11h4"></path>
                                                    <path d="M8 15h3"></path>
                                                    <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"></path>
                                                    <path d="M18.5 19.5l2.5 2.5"></path>
                                                </svg> Abandonment / Soil Verification
                                            </h3>
                                            <p className="text-muted">Provide details of abandonment.</p>
                                        </div>
                                        {/* <!-- Card footer --> */}
                                        <div className="card-footer">
                                            <div className="d-flex">
                                                {inspectionStatusData?.abandonmentInspectionId &&
                                                    inspectionStatusData?.abandonmentInspectionId === InspectionStatus.Complete &&
                                                    (<><a href="#" className="btn btn-link green-btn-link">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <path d="M5 12l5 5l10 -10"></path>
                                                        </svg>Complete</a>
                                                        <a onClick={goToEditAbandonmentPage} className="btn btn-primary ms-auto">Edit</a></>)}
                                                {(inspectionStatusData?.abandonmentInspectionId === null ||
                                                    inspectionStatusData?.abandonmentInspectionId === undefined) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToAbandonmentPage} className="btn btn-primary d-flex">Get Started</a>
                                                        </div>
                                                    </>)}
                                                {inspectionStatusData?.abandonmentInspectionId &&
                                                    (inspectionStatusData?.abandonmentInspectionId === InspectionStatus.Incomplete) &&
                                                    (<>
                                                        <div className="col-sm-12">
                                                            <a onClick={goToEditAbandonmentPage} className="btn btn-primary d-flex">Continue</a>
                                                        </div>
                                                    </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Card.Footer>
                        <div className="d-flex">
                            <span className="btn btn-primary" onClick={goToSearchPage}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Back to Search
                            </span>
                            <div className="btn-list ms-auto">
                                <Button className="btn btn-primary ms-auto" disabled={HideNextButton} onClick={goToSummaryPage}>Next</Button>
                            </div>
                        </div>
                    </Card.Footer>
                </Layout.Container>
            </Page.Body>
        </Page.Container>
    )
};

export default InspectionHomePage;

function setValue(arg0: string, arg1: boolean) {
    throw new Error("Function not implemented.");
}
